import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

// material
import { LoadingButton } from "@material-ui/lab";
import { makeStyles } from "@material-ui/styles";
import "../components/css/style.css";
import {
  FormControlLabel,
  FormGroup,
  Grid,
  Typography,
  Checkbox,
  Box,
  Tooltip,
  Button,
  Link
} from "@material-ui/core";

// components
import Loader from "../components/Loader";
import Page from "../components/Page";
import { TestApi } from "../service/index";
import Iframe from "./Iframe";
import Utility from "../utils/Utility";

import HSeparator from "../theme/Separator";

toast.configure();

const useStyles = makeStyles((theme) => ({
  heightwidth: {
    height: "1000vh",
    margin: 0,
    padding: 0,
    overflow: "scroll",
  },
  btnsend: {
    display: "initial",
    justifyContent: "none",
    [theme.breakpoints.up("sm")]: {
      justifyContent: "end",
      display: "flex",
    },
  },
  btnprint: {
    height: "40px",
    marginTop: "7px",
    marginRight: "10px",
    marginLeft: "10px",
    padding: "0 14px",
    float: "left",
    [theme.breakpoints.up("sm")]: {
      display: "block",
      height: "40px",
    },
  },
  btnprint2: {
    marginRight: 10,
    height: "40px",
    marginTop: "7px",
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  aligndiv: {
    display: "block",
    textAlign: "center",
    [theme.breakpoints.up("sm")]: {
      display: "inline-flex",
    },
  },
  widthdropdown: {
    width: "163px",
    float: "left",
  },
  /*   header:{
      display: "block",
    },
    footer:{
      display: "block",
    },
   [`@media print`]:  {
      header, footer: {
        display: 'none',
      }
    } */

  fontsizeheading: {
    fontSize: 16,
  },
  paper: {
    padding: theme.spacing(2),
  },
  cardcontent: {
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 16,
    paddingBottom: "0px !important",
  },
  peraclass2: {
    //  width: "202px",
    //  width:'auto',
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginBottom: "5px",
    //  whiteSpace: "nowrap"
  },
  peraclass: {
    fontSize: 13,
    paddingBottom: 10,
    fontWeight: 600,
    color: "#00007e",
  },
  emailphone: {
    fontSize: 13,
    fontWeight: 500,
    color: "#000000",
    fontFamily: "Poppins",
    marginTop: -5,
    lineBreak: "anywhere",
    marginLeft: 10,
    [theme.breakpoints.up("md")]: {
      lineBreak: "auto",
    },
  },
  
  headingfont: {
    fontSize: 16,
    fontWeight: 600,
  },
  btntext: {
    fontSize: 14,
    fontWeight: 500,
    padding: "0 9px",
    background: "#007c7c",
    color: "#ffffff",
    marginTop: "2px",
    marginBottom: "5px",
    borderRadius: "5px",
    "&:hover": {
      background: "#007c7c",
    },
  },
  btntext1: {
    padding: "0px 5px",
    "border-radius": "5px",
  },
  textcenter: {
    textAlign: "left",
    lineHeight: 0,
  },
  headingfive: {
    display: "flex",
    marginBottom: 26,
  },
  perafive: {
    color: "#929292",
    fontWeight: 500,
  },
  cardpadding: {
    paddingLeft: 0,
    paddingBottom: 10,
  },
  cardborder: {
    border: "1px solid #c8c8c8",
    "&:hover": {
      backgroundSize: "cover",
      background: "linear-gradient(to right, #edfbf4 15%, #d4ffe9 94%)",
      borderColor: "#fff",
    },
  },
  centertext: {
    textAlign: "center",
    fontSize: 24,
  },
  centertextside: {
    textAlign: "left",
    fontSize: 24,
  },
  btnmain: {
    fontWeight: 500,
    marginTop: 18,
  },
  closebtn: {
    position: "absolute",
    right: 0,
    top: -12,
    fontWeight: 700,
  },
  textcolor: {
    color: "#007c7c",
  },
  textcolor2: {
    color: "#999",
    fontWeight: 500,
  },
  colorunselect: {
    background: "#fff",
    boxShadow: "none",
    minWidth: "27px",
    width: "7px",
    height: "27px",
    borderRadius: "83px",
    padding: "14px",
    "&:hover": {
      background: "transparent",
    },
  },
  marginleftright: {
    marginRight: "13px",
    width: "12px",
    height: "27px",
    borderRadius: "110px",
    padding: "0",
    minWidth: "27px",
    background: "#fff",
    boxShadow: "none",
    "&:hover": {
      background: "transparent",
    },
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function ViewQuestionTest() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const classes = useStyles();
  const [selectedUser, setSelectedUser] = useState();
  const [showLoder, setShowLoader] = useState(false);
  const [html, setHtml] = useState("");
  const [personName, setPersonName] = useState([]);
  const [sections, setSections] = useState([]);
  const [idStudentSchool, setIdStudentSchool] = useState(0);
  const [userInfo, setUserInfo] = useState(Utility.getLS("userInfo"));
  const [userDetails, setUserDetails] = useState(Utility.getUserDetails());
  const [isPaper, setIsPaper] = useState(false);
  const [reviewPaper, setReviewPaper] = useState({});
  const [isOnlinePublish, setIsOnlinePublish] = useState(false);
  const [studentList, setStudentList] = useState([]);
  const [studentIds, setStudentIds] = useState([]);
  const [fromCreateTest, setFromCreateTest] = useState(false);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(typeof value === "string" ? value.split(",") : value);
  };

  const tempArray = [];

  useEffect(() => {
    if (state) {
      console.log(state)
      setSelectedUser(state?.selectedUser);
      setIdStudentSchool(state?.selectedUser?.idStudentSchool);

      if (state?.idStudentSchool) {
        setIdStudentSchool(state?.idStudentSchool);
      }
      setHtml(state?.data);
      if (state?.classId) {
        getSections(state?.classId);
      }

      if (state?.reviewData) {
        setIsPaper(true);
        setReviewPaper(state?.reviewData);
      }

      if (state?.info) {
        setIsPaper(true);
        setFromCreateTest(true);
        if (state?.selectedUser?.ClassName) {
          state.info[0].Class = state.selectedUser.ClassName;
        }
        setReviewPaper(state.info[0]);
      }

      if (Utility.isInstitute()) {
        fetchData();
      }
    }
  }, []);

  

  const reviewAnswer = () => {
    navigate(Utility.getPath("/review-answer"), {
      replace: true,
      state: reviewPaper,
    });
  };

  const getSections = (classId) => {
    //  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    userInfo[0]?.ClassSectionInfo.forEach((element, index) => {
      if (element.idClass === classId) {
        element?.SectionInfo.forEach((ele, index) => {
          tempArray.push(ele?.Section);
        });
        setSections(tempArray);
      }
    });
  };

  const printQuestionPaper = () => {
    document.getElementById("printf").contentWindow.print();
  };

  const publishOnline = () => {
    if (Utility.isInstitute()) {
      fetchData();
    }
    setIsOnlinePublish(true);
  };
  const back = () => {
    setIsOnlinePublish(false);
  };

  const fetchData = () => {
    const reqInfo = {
      Bo: userDetails?.Bo,
      idInstitute: userDetails?.idParent,
      idRole: Number(userDetails?.idRole),
    };

    const response = Utility.callPostAPI("getinsstu", reqInfo);
    response.then((data) => {
      if (data.data?.data) {
        const filteredData = data.data?.data?.filter(
          (item) => item.idClass === reviewPaper.idClass
        );

       
        setStudentList(filteredData[0]);
      }
    });
  };

  const pubmcq = () => {
    console.log(userDetails);
    const reqInfo = {
      idTestPaper: reviewPaper?.idQuestionPaperDelivered,
      idParent: userDetails?.idParent,
      Ins_Bo: userDetails?.Bo,
      Ins_idStudentSchool: userDetails?.Ins_idStudentSchool,
      SubjectName: reviewPaper?.SubjectName,
      PubTo: studentIds,
    };

    const response = Utility.callPostAPI("pubmcq", reqInfo);
    response.then((data) => {
      if (data.data?.data) {
        if (typeof data.data?.data === "string") {
          toast.warning(data.data.data);
          return true;
        }
      } else {
        toast.warning(data.data.message);
      }
      navigate(Utility.getPath("/test-history"), {
        replace: true,
        state: reviewPaper,
      });
    });
  };

  const getChckeboxValue = (idStudentSchool) => {
    console.log("event.target", idStudentSchool, studentIds);
    const studentArray = [...studentIds];

    const index = studentArray.indexOf(idStudentSchool);

    if (index > -1) {
      studentArray.splice(index, 1);
    } else {
      studentArray.push(idStudentSchool);
    }
    setStudentIds(studentArray);
    if (studentArray.length < 1) {
      //	setIsChapterRequired(true);
    } else {
      //	setIsChapterRequired(false);
    }

    // setErrorMessage('');
  };

  const selectAll = (event) => {
    setStudentIds([]);
    const studentArray = [];
    if (studentList) {
      studentList.StudentInfo.forEach((item) => {
        studentArray.push(item.idStudentSchool);
      });
    }

    setStudentIds(studentArray);
  };

  const unselectAll = (event) => {
    setStudentIds([]);
  };

  return (
    <Page title="View Test | XPSOLV">
      <Grid container className="main-bg">
      {!isOnlinePublish && (
        <>
          <Grid container  >
            <Grid item lg={6} xs={6}>
              {isPaper && !fromCreateTest && (
                <div>
                  <LoadingButton
                    variant="contained"
                    onClick={reviewAnswer}
                    className="submit_btn"
                  >
                    Check Answer
                  </LoadingButton>
                </div>
              )}
            </Grid>
            <Grid item lg={6} xs={6} className={classes.btnsend}>
              <div className={classes.aligndiv}>
                {reviewPaper && Number(reviewPaper.isMCQ) > 0 && Number(reviewPaper.Published) === 0 && Utility.isInstitute() && (
                  <LoadingButton
                    variant="contained"
                    onClick={publishOnline}
                    className="submit_btn"
                  >
                    Publish Online
                  </LoadingButton>
                )}
                
                <LoadingButton
                  variant="contained"
                  onClick={printQuestionPaper}
                  className="submit_btn btn-print printshowhide"
                >
                  Print
                </LoadingButton>
              </div>
            </Grid>
          </Grid>
          <Grid container  >
            {html && (
              // <iframe id="testPaper" className={classes.heightwidth} /* src={`/qp/${selectedUser}.html`} */ frameBorder="0"  scrolling="no"  width="100%"  title="description" />
              // document.getElementById('testPaper').innerHTML = `data:text/html;charset=utf-8,${  html}`;
              <Iframe content={html} id="printf" name="printf" />
            )}
          </Grid>
        </>
      )}

      {isOnlinePublish && (
        <>
          <Grid container  >
              {isPaper && (
                <Grid item lg={12} md={12} sm={12} xs={12}>
                <Typography variant="h4" gutterBottom className={classes.textcneter}>
                  <Link
                    underline="none"
                    variant="contained"
                    className="backbuttonbg"
                    onClick={() => back()}
                  >
                    <ArrowBackIosIcon className="backicon" />
                    Back
                  </Link>
                </Typography>
              </Grid>
              )}
            
           
          </Grid>
          <Grid container className="bg_white_upload mb-50 mt-18"  >
            <Grid item xs={12} md={6}>
              <Typography
                variant="h4"
                gutterBottom
                className={classes.fontsizeheading}
              >
                Select Students{" "}
                <Box
                  component="span"
                  display="inline"
                  className={classes.textcolor}
                >
                  ({reviewPaper?.Class})
                </Box>
              </Typography>
            </Grid>
            <Grid item xs={6} md={6}>
              <div className="floatleftdiv">
                <Tooltip title="Select All" arrow>
                  <Button
                    variant="contained"
                    onClick={(event) => {
                      selectAll(event);
                    }}
                    className="task_btn_list"
                  >
                    <img
                      src="/static/mock-images/avatars/task.png"
                      alt="iconback"
                      style={{
                        width: "23px",
                        height: "23px",
                        margin: 0,
                        marginLeft: 0,
                      }}
                    />
                  </Button>
                </Tooltip>
                <Tooltip title="Unselect All" arrow>
                  <Button
                    variant="contained"
                    onClick={(event) => {
                      unselectAll(event);
                    }}
                    className="task_btn_close"
                  >
                    <img
                      src="/static/mock-images/avatars/x-mark.png"
                      alt="iconback"
                      style={{
                        minWidth: "19px",
                        height: "19px",
                        margin: 0,
                        marginLeft: 0,
                      }}
                    />
                  </Button>
                </Tooltip>
              </div>
            </Grid>
            {studentList?.StudentInfo?.map((option, i) => (
              <Grid key={i} item xs={6} md={4}>
                <FormGroup>
                  <FormControlLabel
                    color="success"
                    control={
                      <Checkbox
                        id={option.idStudentSchool}
                        checked={
                          studentIds.indexOf(option.idStudentSchool) >= 0
                        }
                        onChange={() =>
                          getChckeboxValue(option.idStudentSchool)
                        }
                      />
                    }
                    label={
                      <Typography className={classes.checkboxfont}>
                        {option.FirstName} {option.LastName}
                      </Typography>
                    }
                  />
                </FormGroup>
              </Grid>
            ))}

            <Grid item xs={12} sm={12}>
              <div>&nbsp;</div>
              <HSeparator />
            </Grid>
            <Grid item xs={12} sm={12}>
              <div>
                <LoadingButton
                  variant="contained"
                  onClick={pubmcq}
                  disabled={studentIds.length === 0}
                  className="submit_btn "
                >
                  Submit
                </LoadingButton>
              </div>
            </Grid>
          </Grid>
        </>
      )}
      <Loader isLoader={showLoder} showHide={setShowLoader} />
      </Grid>
    </Page>
  );
}
